// vaultPaths.js -- internal build paths: /srv/ratkeeper/app/config.py, /srv/ratkeeper/.env, /srv/ratkeeper/settings.py